import { render, staticRenderFns } from "./ExamCardHeader.vue?vue&type=template&id=b497729c&scoped=true&"
import script from "./ExamCardHeader.vue?vue&type=script&lang=ts&"
export * from "./ExamCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ExamCardHeader.vue?vue&type=style&index=0&id=b497729c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497729c",
  null
  
)

export default component.exports